import { createSlice } from "@reduxjs/toolkit";

const initialWinnerDetailsSlice = { data: {}, isOpen: false }

const winnerDetailsSlice = createSlice({
    name: 'winnerDetailsSlice',
    initialState: initialWinnerDetailsSlice,
    reducers: {
        openModal(state, action) {
            state.data = action.payload
            state.isOpen = true
        },
        closeModal(state, action) {
            state.data = {}
            state.isOpen = false
        }
    }
})

export const winnerDetailsActions = winnerDetailsSlice.actions;
export default winnerDetailsSlice